<div class="wrapper">
    
       <!--start content-->
       <main class="authentication-content">
        <div class="container-fluid">
          <div class="authentication-card">
            <div class="card shadow rounded-0 overflow-hidden">
              <div class="row g-0">
                <div class="col-lg-6 bg-login d-flex align-items-center justify-content-center">
                  <img src="assets/images/error/login-img.jpg" class="img-fluid" alt="">
                </div>
                <div class="col-lg-6">
                  <div class="card-body p-4 p-sm-5">
                    <div class="text-center">
                        <h1>TheAlgoHopper-Bot</h1><br />
                        <h5 class="card-title">Sign In</h5>
                    </div>
                    <form class="form-body" [formGroup]="validator.loginForm" novalidate autocomplete="off">
                        <hr />
                        <div class="row g-3">
                          <div class="col-12">
                            <label for="inputEmailAddress" class="form-label">Email Address</label>
                            <div class="ms-auto position-relative">
                              <div class="position-absolute top-50 translate-middle-y search-icon px-3"><i class="bi bi-envelope-fill"></i></div>
                              <input type="email" class="form-control radius-30 ps-5" id="inputEmailAddress" placeholder="Email Address" formControlName="username"
                                [ngClass]="{ 'is-invalid': validator.submitted && validator.f['username'].errors }">
                            </div>
                            <div *ngIf="validator.submitted && validator.f['username'].errors" class="invalid-feedback">
                                <div *ngIf="validator.f['username'].errors['required']">username is required.
                                </div>
                            </div>
                          </div>
                          <div class="col-12">
                            <label for="inputChoosePassword" class="form-label">Enter Password</label>
                            <div class="ms-auto position-relative">
                              <div class="position-absolute top-50 translate-middle-y search-icon px-3"><i class="bi bi-lock-fill"></i></div>
                              <input type="password" class="form-control radius-30 ps-5" id="inputChoosePassword" placeholder="Enter Password" formControlName="password"
                                [ngClass]="{ 'is-invalid': validator.submitted && validator.f['password'].errors }">
                            </div>
                            <div *ngIf="validator.submitted && validator.f['password'].errors" class="invalid-feedback">
                                <div *ngIf="validator.f['password'].errors['required']">password is required.
                                </div>
                            </div>
                          </div>
                          

                          <div class="col-12">
                            <label>By logging in, you agree to all the <a
                            href="javascript:void(0)" (click)="openTermsAndConditions()"
                            title="Terms and Conditions">Terms and Conditions</a></label>
                          </div>
                          
                          <div class="col-12">
                            <div class="d-grid">
                              <button type="button" class="btn btn-primary radius-30" (click)="doLogin()">Sign In</button>
                            </div>
                          </div>
                          
                        </div>
                    </form>
                 </div>
                </div>
              </div>
            </div>
          </div>
        </div>
       </main>
        
       <!--end page main-->

  </div>

<div class="modal fade" data-backdrop="static" data-keyboard="false" id="termsAndConditionsModal" tabindex="-1" role="dialog"
  aria-labelledby="termsAndConditionsModal" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-xl" role="document">
    <div class="modal-content py-3">
      <div class="modal-header">
        <h5 class="modal-title">Terms And Conditions</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <!-- <div class="modal-body px-5">
        <div class="row">
          <div class="col-md-10">
            <h5>Terms And Conditions</h5>
          </div>
          <div class="col-md-1">
            <span aria-hidden="true" class="close" data-dismiss="modal" aria-label="Close"
              style="cursor: pointer">&times;</span>
          </div>
        </div> -->
      <div class="modal-body row">
            <div class="col-md-12">
                <p>
                    By using TheAlgohopper (thealgohopper.com) and its services (website, algos, tools, product etc.) you agree to the following terms of use.
                </p>
                <p>
                    The website located at <a href="https://thealgohopper.com" target="_blank">https://thealgohopper.com</a> (the “Site”) is a copyrighted work and certain features
                    of the Site may be subject to additional guidelines, terms, or rules, which will be posted on the
                    Site in connection with such features, including, without limitation the Company’s Privacy Policy,
                    the Platform Services Agreement, the Subscription and Sublicense Agreement, all of which are
                    incorporated by reference to these Terms. All such additional terms, guidelines, and rules are
                    incorporated by reference into these Terms.
                </p>
                <p>
                    THESE TERMS OF USE (THESE “TERMS”) SET FORTH THE LEGALLY BINDING TERMS AND CONDITIONS THAT GOVERN
                    YOUR USE OF THE SITE. BY ACCESSING OR USING THE SITE, YOU ARE ACCEPTING THESE TERMS (ON BEHALF OF
                    YOURSELF OR THE ENTITY THAT YOU REPRESENT), AND YOU REPRESENT AND WARRANT THAT YOU HAVE THE RIGHT,
                    AUTHORITY, AND CAPACITY TO ENTER INTO THESE TERMS (ON BEHALF OF YOURSELF OR THE ENTITY THAT YOU
                    REPRESENT). YOU MAY NOT ACCESS OR USE THE SITE OR ACCEPT THE TERMS IF YOU ARE NOT AT LEAST 18 YEARS
                    OLD. IF YOU DO NOT AGREE WITH ALL OF THE PROVISIONS OF THESE TERMS, DO NOT ACCESS AND/OR USE THE
                    SITE.
                </p>
                <p>
                    THIS AGREEMENT REQUIRES THE USE OF ARBITRATION ON AN INDIVIDUAL BASIS TO RESOLVE DISPUTES, RATHER
                    THAN JURY TRIALS OR CLASS ACTIONS, AND ALSO LIMITS THE REMEDIES AVAILABLE TO YOU IN THE EVENT OF A
                    DISPUTE. PLEASE CAREFULLY READ THESE TERMS OF USE BEFORE ACCESSING THE SITE OR USING ANY OF THE
                    SERVICES. IF YOU DO NOT WISH TO BE BOUND BY THESE TERMS AND CONDITIONS OR IF YOU CANNOT REMAIN IN
                    COMPLIANCE WITH SUCH TERMS AND CONDITIONS, YOU MAY NOT ACCESS THE SITE OR USE ANY OF THE SERVICES
                    AND SHOULD IMMEDIATELY CEASE SUCH ACCESS AND USE.
                </p>
                <p>
                    In order to use certain features of the Site, you must register for an account (“Account”) and
                    provide certain information about yourself as prompted by the account registration process. You
                    represent and warrant that: (a) all required registration information you submit is truthful and
                    accurate; (b) you will maintain the accuracy of such information.
                </p>
                <p>
                    You are responsible for maintaining the confidentiality of your Account login information and are
                    fully responsible for all activities that occur under your Account.
                </p>
                <p>
                    YOU ARE ENTIRELY RESPONSIBLE FOR ANY AND ALL ACTIVITIES AND CONDUCT, WHETHER BY YOU OR ANYONE ELSE,
                    THAT ARE CONDUCTED THROUGH YOUR ACCOUNT.
                </p>
                <p>
                    You agree to immediately notify Company of any unauthorized use, or suspected unauthorized use of
                    your Account or any other breach of security. Company cannot and will not be liable for any loss or
                    damage arising from your failure to comply with the above requirements.
                </p>
                <p>
                    You are prohibited from soliciting or recruit any other users or members of the Site, for any
                    reason, unless you have requested and received permission to solicit or recruit in writing from the
                    Company. This prohibition includes a prohibition against soliciting or recruiting users of the Site,
                    to become members of competitive sites and services. If you violate this policy, the Company
                    reserves the right to terminate your Account without notice and to take legal action to recover lost
                    revenues plus applicable damages. By using the Site, you specifically acknowledge that you agree to
                    this prohibition.
                </p>
                <p>
                    Subject to these Terms, Company grants you a non-transferable, non-exclusive, revocable, limited
                    license to use and access the Site solely for your own personal use.
                </p>
                <p>
                    The rights granted to you in these Terms are subject to the following restrictions: (a) you shall
                    not license, sell, rent, lease, transfer, assign, distribute, host, or otherwise commercially
                    exploit the Site, whether in whole or in part, or any content displayed on the Site; (b) you shall
                    not modify, make derivative works of, disassemble, reverse compile or reverse engineer any part of
                    the Site; (c) you shall not access the Site in order to build a similar or competitive website,
                    product, or service; and (d) except as expressly stated herein, no part of the Site may be copied,
                    reproduced, distributed, republished, downloaded, displayed, posted or transmitted in any form or by
                    any means. Unless otherwise indicated, any future release, update, or other addition to
                    functionality of the Site shall be subject to these Terms. All copyright and other proprietary
                    notices on the Site (or on any content displayed on the Site) must be retained on all copies
                    thereof.
                </p>
                <p>
                    Company reserves the right, at any time, to modify, suspend, or discontinue the Site (in whole or in
                    part) with or without notice to you. You agree that Company will not be liable to you or to any
                    third party for any modification, suspension, or discontinuation of the Site or any part thereof.
                </p>
                <p>
                    You acknowledge and agree that Company will have no obligation to provide you with any support or
                    maintenance in connection with the Site, but the Company reserves the right, on a case by case
                    basis, to provide support or maintenance as the need arises.
                </p>
                <p>
                    Subject to the terms hereof, and excluding any Non-Public User Content that you may provide, you
                    acknowledge that all the intellectual property rights, including copyrights, patents, trademarks,
                    and trade secrets, in the Site and its content, whether provided by you, the Company, or Company’s
                    suppliers, are owned by Company or Company’s suppliers. Neither these Terms (nor your access to the
                    Site) transfers to you or any third party any rights, title or interest in or to such intellectual
                    property rights. Company and its suppliers reserve all rights not granted in these Terms. There are
                    no implied licenses granted under these Terms.
                </p>

                <h6>No Investment Advice; Not an Investment Advisor; Not a Broker-Dealer.</h6>
                <p>
                    The Company is not an investment advisory service, nor is it a registered investment advisor or
                    broker-dealer and does not purport to tell or suggest the value of any securities or which
                    securities customers should buy or sell for themselves. The users of the Site may hold positions in
                    the indices, stocks or industries. You understand and acknowledge that there is a very high degree
                    of risk involved in trading securities. The Company, the users, the authors, the publisher, and all
                    affiliates of the Site assume no responsibility or liability for your trading and investment
                    results. Factual statements or publications on the Site are made as of the date stated and are
                    subject to change without notice. It should not be assumed that the methods, techniques, or
                    indicators presented in these products will be profitable or that they will not result in losses.
                    Past results of any individual trader or trading system published by on the Site are not indicative
                    of future returns by that trader or system, and are not indicative of future returns which be
                    realized by you. In addition, the indicators, strategies, columns, articles and all other features
                    of the Site are provided for informational and educational purposes only and should not be construed
                    as investment advice. Examples presented on the site are for educational purposes only. Such set-ups
                    are not solicitations of any order to buy or sell. Accordingly, you should not rely solely on the
                    Information in making any investment. You should always check with your licensed financial advisor
                    and tax advisor to determine the suitability of any investment.
                </p>

                <h6>Live Trading Risks</h6>
                <p>
                    By using the Site, you acknowledge and agree that live algorithmic trading has various risks and the
                    Company shall not have any liability for any losses incurred through using the Site, such risks
                    included, without limitation:
                </p>
                <ol type="a">
                    <li>Design risks; errors in data, incorrect assumptions, logical program errors. Even if you
                      designed a perfect strategy, past performance is no guarantee of future results.</li>
                    <li>Design risks; errors in data, incorrect assumptions, logical program errors. Even if you
                    designed a perfect strategy, past performance is no guarantee of future results.</li>
                    <li>Loss of internet connectivity; resulting in disconnections from brokerage, trades not placed,
                      not seeing the results of algorithm, orders failing to be placed.</li>
                    <li>Poor design of algorithm; resulting in runaway strategies, machine gun orders, run-time errors
                      halting program operation, failure to trade when expected, termination of the algorithm.</li>
                    <li>Unexpected market conditions; resulting in poor fill prices, rapid losses (flash crashes), late
                      exchange openings.</li>
                    <li>Data issues; broken, dirty, delayed or intermittent data connections causing algorithm errors.
                      This includes data inaccuracies (exchanges sometimes publish bad/fictional trades).</li>
                    <li>Execution issues; orders submissions, updates and cancellations could be rejected or delayed.
                      Trades could be disallowed by authorities without warning.</li>
                    <li>Malicious activities; criminal activity could cause your algorithm to fail or your brokerage
                      account to become compromised, leaking personal information, intellectual property or theft of
                      your funds.</li>
                    <li>These events can cause the loss of all funds and holdings in your brokerage account. Algorithmic
                      trading losses can occur faster than in manual trading and you should consult an investment
                      professional to discuss these risks. You should continually monitor the operation of a live
                      trading algorithm to ensure it is running properly.</li>
                    </ol>
                <p>
                    EVERY TIME YOU USE THE SITE YOU AGREE THAT IN ALL CASES THE COMPANY BEARS NO RESPONSIBILITY FOR
                    LOSSES INCURRED, AND OFFERS NO GUARANTEES OR EXPECTATIONS ON YOUR ALGORITHM PERFORMANCE OR
                    STABILITY.
                </p>
                <h6>Risk Disclosure</h6>
                <p>
                    TheAlgoHopper Bot is not responsible for any loss, including without limitation, any loss of profit, which
                    might come up directly or indirectly from the use of or the dependence on systems and authorizations
                    provided by us. TheAlgoHopper Bot cannot be held responsible for the accuracy of any tools, services and
                    systems made accessible through the site.
                </p>
                <p>
                    Any news, analysis, research, opinions, prices, or any other information provided by TheAlgoHopper Bot
                    through thealgohopper.com (blog or YouTube channel) cannot be established as an investment
                    recommendation. TheAlgoHopper cannot be held liable for any form of loss or
                    damage, in addition to without limitation, any loss that may be encountered directly or indirectly
                    from the utilization of or dependency on such information.
                </p>
                <p>
                    Trading contains substantial risk and is not for every investor. An investor could potentially lose
                    all or more than the initial investment. Risk capital is money that can be lost without jeopardizing
                    ones financial security or life style. Only risk capital should be used for trading and only those
                    with sufficient risk capital should consider trading.
                </p>
                <p>
                    There is a very high degree of risk involved in trading. Past results are not indicative of future
                    returns.thealgohopper.com and all
                    individuals affiliated with this site or Channel assume no responsibilities for your trading and
                    investment results. The indicators, strategies, columns, articles and all other features are for
                    educational purposes only and should not be construed as investment advice. Information for
                    stock/Nifty/Banknifty observations are obtained from our own experience in market , but we do not
                    warrant its completeness or accuracy, or warrant any results from the use of the information. Your
                    use of the stock/Nifty/Banknifty observations is entirely at your own risk and it is your sole
                    responsibility to evaluate the accuracy, completeness and usefulness of the information. You must
                    assess the risk of any trade with your broker and make your own independent decisions regarding any
                    securities mentioned herein.You must consult your financial advisor before taking any action in
                    stock market.
                </p>
                <p>
                    Past performance results are shown for illustration and example only, are hypothetical and as such
                    have many inherent limitations. No representation is being made that any account will or is likely
                    to achieve profits or losses similar to those shown. In fact, there are frequently significant
                    differences between hypothetical performance results and the actual results subsequently achieved by
                    any particular trading technique or methodology. One of the limitations of hypothetical performance
                    results is that they are prepared with the benefit of hindsight. In addition, hypothetical trading
                    does not involve financial risk, and no hypothetical trading record can completely account for the
                    impact of financial risk in actual trading. For example, the ability to withstand losses or adhere
                    to a particular trading program despite trading losses are material factors which can adversely
                    affect actual trading results. There are numerous other factors related to the markets in general or
                    to the implementation of any specific trading program which can not be fully accounted for in a
                    preparation of hypothetical performance results and all of which can adversely affect actual trading
                    results.
                </p>
                <h6>Technology Risks</h6>
                <p>
                    You should be aware that using API service involves many uncertain factors and complex hardware,
                    software, systems, communication lines, peripherals etc. The Member Broker and/or your Software
                    Vendor do not make any commitment, warranty or promises that this API service will be available to
                    you at all times without any interruption/fail.
                </p>
                <p>
                    we reserve all the rights to maintain disciplinary approach in case of any emergency
                    You should carefully consider whether this API based trading is suitable for you in light of your
                    financial condition or otherwise. Member Broker/Software Vendor shall not be responsible for lost
                    profits, revenues, or data; financial losses; or indirect, special, consequential, exemplary, or
                    punitive damages. You are hereby informed, and by proceeding to trade duly acknowledge and accept
                    that there can be no guarantee of profits or no exception from losses while executing orders by
                    using the API Facility. All trades are subject to market risk and are to your trading account. if
                    your oder didnt go through due to API ERROR , Contact your Respective Broker.
                </p>
                <p>
                    Confidential information including credentials (such as passwords, API keys and secrets, and Client
                    IDs) and order history (details of orders submitted, modified, cancelled) are stored on our servers
                    and are not intended to reveal to anyone. In case of investigation, we might use all or any of above
                    information to resolve any technical issue. You are fully aware of this flow process and if you do
                    not wish agree, please stop proceeding further and not register with us. Your Software Vendor may
                    have access to diagnostic information related to application crash or performance issues which is
                    used for betterment of API.
                </p>
                <p>
                    TheAlgoHopper Bot allows you to engage in live trading using the broker’s API access given to you by the
                    broker. Engaging in live trading subjects you to:
                </p>
                <ol type="a">
                    <li>the risks associated with trading generally, and</li>
                    <li>
                        the risks associated with live algorithmic trading using TheAlgoHopper Bot.
                        <p>
                          The occurrence of any of the events associated with these risks, alone or in combination with
                          any of
                          the other risks described in this disclosure statement, could result in the loss of all of the
                          money
                          you have deposited in the brokerage account you use for live trading based on the strategies
                          you
                          write, test, and run on TheAlgoHopper Bot. Losses can happen more quickly when using algorithmic
                          trading
                          than other forms of trading. You should discuss with an investment professional the risks of
                          trading
                          in general and algorithmic trading in particular. You use any strategy in live trading at your
                          own
                          risk and it is your obligation to thoroughly and appropriately test any trading strategy
                          before you
                          deploy it and to continually monitor the operation of any deployed trading strategy to ensure
                          it is
                          running properly and in compliance with any applicable rules.
                        </p>
                        <h6>Other technology related terms and conditions:</h6>
                        <ol type="i">
                          <li>Any or all of the systems comprising our infrastructure could entirely or partially fail,
                            function erratically, or function very slowly (thereby leading to latency, i.e., delays in
                            receipt
                            of and response to user requests).</li>
                          <li>We may inadvertently cause a systems failure during planned or unplanned system
                            maintenance.</li>
                          <li>We may undertake software upgrades, either planned or unplanned, that take longer to
                            implement
                            or that causes your computer system or Internet connectivity to fail.</li>
                          <li>We may change or remove functions and features whose change or removal causes your system
                            to
                            fail, function erratically, or function very slowly.</li>
                        </ol>
                    </li>
                    <li>
                        Your computer system and your Internet connectivity may fail.
                        <p>
                          Any of the components of your computer system and/or your Internet connectivity could fail
                          entirely,
                          function erratically, or function very slowly. The result of any of these occurrences could
                          make it
                          difficult or impossible for you to access the TheAlgoHopper Bot Site or Services.
                        </p>
                        <p>
                          You may incur losses (or fail to gain profits) while trading securities. You should discuss
                          the
                          risks of trading with the broker-dealer where you maintain an account or other investment
                          professional. TheAlgoHopper Bot provides you only with trading technology and can provide no
                          investment,
                          financial, regulatory, tax or legal advice.
                        </p>
                    </li>
                </ol>
                <p>
                    Trading algorithms is subject to several risks, any of which can cause your algorithms to not
                    function as you had intended or fail to achieve one or more of the objectives of your algorithms.
                    Algorithmic trading is rapidly changing as a practice and as an industry. Models of markets used to
                    write and test trading algorithms are inherently limited and often fail to perform as expected. In
                    addition, trading algorithms are implemented in software programming code, and no matter how well
                    designed and thoroughly tested, any such code can have logical errors and bugs that cause the
                    algorithms to malfunction or suggest trades that, if executed, would result in losses. It is your
                    obligation to thoroughly and appropriately test any trading algorithm before you deploy it and to
                    continually monitor the operation of any deployed trading algorithm to ensure it is running properly
                    and in compliance with any applicable rules
                </p>
                <ol type="a">
                    <li>Your algorithm may be designed on the basis of an incorrect understanding of technical
                      indicators which may not work as expected.</li>
                    <li>Your algorithm may contain logical errors in the way you understand the indicators and
                      comparators.</li>
                    <li>Errors may exist in the data used for testing your algorithm or the applicable model of the
                      market.</li>
                    <li>Your algorithm might appear to succeed in a backtesting environment using historical data.</li>
                    <li>Your algorithm might appear to succeed with some data sources, but fail when using other data
                      sources in our system.</li>
                    <li>Your algorithm may not achieve the returns you anticipate. There are no guarantees, or even
                      expectations, that can be made about the future behavior of an algorithm.</li>
                    <li>
                        Backtesting Cannot Assure Actual Results.
                        <ul>
                            <li>
                                It is not possible for a computer model to truly predict what might have happened if an
                                algorithm-based trading strategy was in play in a live trading environment. For example,
                                the
                                implementation of such a strategy can itself have an impact on the market, and the model
                                may fail to
                                account for real-life factors that impact the model. Moreover, the model may fail to
                                account for
                                execution costs including broker commissions, fees, and trading slippage.
                            </li>
                            <li>
                                A promising model result does not necessarily predict a successful strategy. A backtest
                                might be
                                over-fitted to past data, and fail when the strategy is applied to new, live data. Your
                                algorithm
                                might not handle market conditions that cannot be reasonably anticipated, i.e., a “flash
                                crash” or
                                an exchange outage. These market conditions, by definition, will not have been tested.
                            </li>
                        </ul>
                    </li>
                    <li>
                      The relevant market might fail or behave unexpectedly. Market centers in which you seeking to
                      implement your trading strategy may fail or behave incorrectly because of technical reasons
                      relating to infrastructure, connectivity, and similar factors.
                      <ul>
                        <li>
                          Your algorithm might suffer from adverse market conditions. Those conditions can include a
                          lack of liquidity and abrupt and unwarranted price swings. Also possible are late market
                          openings, early market closings, market chaos, and mid-day trading pauses, and other such
                          disruptive events.
                        </li>
                      </ul>
                    </li>
                    <li>You may receive incorrect information, or be unable to get information, about your orders, your
                      positions, or market conditions. Incorrect actions may be taken, or corrective actions may not be
                      taken, because of inaccurate or missing information. In addition, you may be unable to terminate
                      or edit your algorithm.</li>
                    <li>Malicious and criminal activities might cause your algorithms and strategy to fail.
                        <ul>
                          <li>
                            All computers and networks are subject to malicious “hacking” attacks and criminal
                            activities designed to misappropriate the intellectual property, compromise personally
                            identifiable information, steal funds, or any combination of such purposes. These attacks
                            might be attacks on a target of opportunity or specifically targeted. Any such attack could
                            cause the system so attacked to function improperly or not at all and could result in the
                            misappropriation of your intellectual property, the compromise of your personally
                            identifiable information and personal financial information, the theft of your funds and can
                            cause your algo to be misbehave, malfunction or behave erratically. TheAlgoHopper Bot cannot be
                            held liable and no legal action can be initiated against aforesaid website, in any case of
                            an external attack by a malicious entity that leads to disclosure of personal data,
                            algorithms or any other data a user has created, submitted or stored with TheAlgoHopper Bot. Trade
                            Bots, in any case, be held liable to any loss of intellectual property, content, harm to
                            reputation, damage, etc.
                          </li>
                          <li>
                            TheAlgoHopper Bot relies on third party services for market data eg. data streaming via Alice Blue
                            or Zerodha subscribed by you (the user) for ticks, OHLCV, status updates, order execution
                            etc. If these services are down or unsubscribed due to unforeseen circumstances or
                            experience a down time due to various technical / non technical issues, TheAlgoHopper Bot might not
                            be able to execute orders at all.
                          </li>
                        </ul>
                    </li>
                </ol>
                <h6>Privacy Policy </h6>
                <p>
                    We use your Personal Information only for providing and improving the Site. By using the Site, you
                    agree to the collection and use of information in accordance with this policy.
                </p>
                <h6>Information Collection And Use</h6>
                <p>While using our Site, we may ask you to provide us with certain information that can be used to
                  contact or identify you. </p>
                <h6>Log Data</h6>
                <p>Like many site operators, we collect information that your browser sends whenever you visit our Site.</p>
                <p>This Log Data may include information such as your computer's Internet Protocol ("IP") address,
                  browser type, browser version, the pages of our Site that you visit, the time and date of your visit,
                  the time spent on those pages and other statistics.</p>
                <p>In addition, we may use third party services such as Google Analytics that collect, monitor and
                  analyze this.</p>

                <h6>
                    Communications
                </h6>
                <p>We may use your Personal Information to contact you with newsletters, marketing or promotional
                  materials and other information that</p>

                <h6>Cookies</h6>
                <p>Cookies are files with small amount of data, which may include an anonymous unique identifier.
                  Cookies are sent to your browser from a web site and stored on your computer's hard drive.</p>
                <p>Like many sites, we use "cookies" to collect information. You can instruct your browser to refuse all
                  cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not
                  be able to use some portions of our Site.</p>

                <h6>Security</h6>
                <p>The security of your Personal Information is important to us, but remember that no method of
                  transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to
                  use commercially acceptable means to protect your Personal Information, we do not guarantee 100%
                  protection. </p>
                <p>
                    In addition to our own cookies, we may also use various third-parties cookies to report usage
                    statistics of the Service, deliver advertisements on and through the Service, and so on.
                </p>

                <h6>What are your choices regarding cookies</h6>
                <p>If you'd like to delete cookies or instruct your web browser to delete or refuse cookies, please
                  visit the help pages of your web browser.</p>
                <p>Please note, however, that if you delete cookies or refuse to accept them, you might not be able to
                  use all of the features we offer, you may not be able to store your preferences, and some of our pages
                  might not display properly.</p>
                <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these
                  Terms. These Terms apply to all visitors, users and others who access or use the Service.</p>
                <p>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part
                  of the terms then you may not access the Service.</p>
                <p>By purchasing our goods and services, you agree to our terms and conditions of not sharing our
                  product or services with anyone without our prior approval. If we find that our terms and conditions
                  have been violated, we reserve the right to revoke licence for the product/service that we have sold
                  to a person who has violated our terms.</p>

                <h6>Disputes</h6>
                <p>A. All disputes / differences / controversies of whatever nature irrespective of whether or not the
                  member concerned is a buyer/user of TheAlgoHopper or in collaboration with any other
                  person/entity including any dispute, difference or controversy in regard to the
                  interpretation/meaning/application of this clause shall be referred to Arbitration by one arbitrator
                  to be jointly and mutually appointed by the parties and the said arbitration shall be governed by the
                  Arbitration and Conciliation Act 1996 (hereinafter refer as “the said Act”). The place of arbitration
                  shall be Hyderabad only.</p>
                <p>B. In all cases where “Court” has jurisdiction to entertain, try and dispose of matters governed by
                  and/arising under or taken under any provision of the said Act, the party/ies shall take/institute
                  such proceedings in an appropriate Court in Hyderabad alone to the exclusion of all other courts in
                  the rest of India</p>
                
                <h6>Purchases</h6>
                <p>If you wish to purchase any product or service made available through the Service, you may be asked
                  to supply certain information relevant to your Purchase including, without limitation. The
                  product/service purchased from this website is not be shared with anyone without our prior approval.
                  Only buyer has access to our products and services.</p>

                <h6>Refund Policy</h6>
                <p>We do not offer any refund on any subscription, live trading, or in any other condition. The company
                  cannot be held liable in an case, including but not limited to technical, trading or any other concern
                  of the user. The user acknowledges that any transaction made, from live trading to payments, on, by,
                  through the platform is as per his discretion and is fully aware of the risks and features provided.
                </p>

                <h6>Disclaimer</h6>
                <p>In no event shall TheAlgoHopper Bot be liable for any special, direct, indirect, consequential, or
                  incidental damages or any damages whatsoever, whether in an action of contract, negligence or other
                  tort, arising out of or in connection with the use of the Service or the contents of the Service.
                  TheAlgoHopper Bot reserves the right to make additions, deletions, or modification to the contents on the
                  Service at any time without prior notice. TheAlgoHopper Bot does not warrant that the website is free of
                  viruses or other harmful components.</p>
            </div>
      </div>
    </div>
  </div>
</div>
